/**
 * @typedef {Object} OrgSettingsResponseDto
 * @property {string} orgId
 * @property {string} orgName
 * @property {string} orgCode
 * @property {number} [defaultWarehouseId]
 * @property {string} [defaultWarehouseName]
 */

const BASE_PATH = 'v1/Organization';

export default function (instance) {
  return {
    getSettings() {
      return instance.get(`${BASE_PATH}/settings`);
    },

    // Unlike getSettings(), any logged-in user can call this - just what an
    // order-creation dialog needs to default its warehouse picker. The
    // integration API token lives per customer - see api/customer.js.
    getDefaultWarehouse() {
      return instance.get(`${BASE_PATH}/default-warehouse`);
    },

    updateDefaultWarehouse(warehouseId) {
      return instance.put(`${BASE_PATH}/default-warehouse`, { warehouseId });
    }
  };
}
